export const Config = {
	environment: 'production',
	sentry     : {
		dsn        : 'https://5021674b2e135fe644aec7b40637737f@trace.windware.net/3',
		sample_rate: 0.1,
	},
}
